import React from "react";
import useTitle from "../../../Hooks/useTitle";
import Projects from "../Projects/Projects";
import HeroSection from "../Shared/HeroSection/HeroSection";
import Skills from "../Skills/Skills";

const Home = () => {
  useTitle("Portfolio");
  return (
    <div>
      <HeroSection></HeroSection>
      <Projects></Projects>
      <Skills></Skills>
    </div>
  );
};

export default Home;
